<template>
  <div>
    <div id="order-label-print" class="w-full grid grid-cols-2 justify-center">
      <div v-for="item in storageUnit" :key="item.id">
        <div class="h-full w-full">
          <div class="mx-auto text-center">
            <qrcode-vue level="L" class="w-full h-full" size="140" :value="item && item.storage_location ? `${item.storage_location.id}-${item.ops_id}` : ''"/>
            <p class="font-medium text-center text-xl">{{item && item.storage_location ? `${item.storage_location.id}-${item.ops_id}` : ''}}</p>
            <p class="font-medium text-center text-5xl">{{item && item.storage_location ? `${item.ops_id}` : ''}}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import QrcodeVue from 'qrcode.vue'

export default {
  props: ['storageUnit'],
  components: {
    QrcodeVue
  }
}
</script>

<style lang="scss">
@media print{
  @page {
    size: letter;
  }
  #shipblu-chat-launcher,
  #shipblu-chat-frame,
  #fc_frame {
    display: none;
  }
  .shipment-page,
  .dropdown-menu{
    *{
      visibility: hidden;
      color: black;
    }
    #order-label-print,
    #order-label-print *{
      visibility: visible;
    }
    #order-label-print{
      display: block;
    }
    #content-area {
      margin: 0 !important;
    }
    #order-label-print {
      position: absolute;
      left: 0;
      top: 0;
      box-shadow: none;
    }
  }
}
</style>